export default function MessageImageSkeleton() {
  return (
    <div className="relative h-[20rem] w-[30rem] animate-pulse rounded-[2rem] bg-gray-200">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-secondary border-t-transparent" />
      </div>
    </div>
  );
}
